import {useTimezonesStore} from 'entities/timezones/model/store.ts';
import {useUserStore} from 'entities/user';
import {useApiariesStore} from 'entities/apiaries';
import {useCalendarStore} from 'entities/calendar';
import {useNotificationState} from 'entities/notifications';
import {toast} from 'react-toastify';
import {useState} from 'react';
import {useMercuryStore} from 'entities/mercury';
import {useDiaryStore} from 'entities/diary';
import {useCurrentHiveStore} from 'entities/currentHive';
import {getNowForUserTz} from 'features/calendar/helpers/dates.ts';
import {useHivesSoundsStore} from 'entities/hiveSound';

export const useTimezoneUpdate = () => {
  const timezones = useTimezonesStore((s) => s.timezones);
  const user = useUserStore((s) => s.userInfo);
  const updateUserTz = useUserStore((s) => s.updateUserTz);
  const currentApiary = useApiariesStore((s) => s.currentApiary());
  const getEventsFromServer = useCalendarStore((s) => s.getEventsFromServer);
  const getNotificationsFromServer = useNotificationState((s) => s.getNotificationsFromServer);
  const getJournalEntries = useMercuryStore((s) => s.getJournalEntries);
  const getDiaryEntriesTyped = useDiaryStore((s) => s.getDiaryEntriesFromServer);
  const getCurrentHiveInfo = useCurrentHiveStore((s) => s.fetchById);
  const setUserNowDate = useUserStore((s) => s.setUserNowDate);
  const getAudiosFromServer = useHivesSoundsStore((s) => s.getAudiosFromServer);

  const [activeTz, setActiveTz] = useState(user?.timezone || null);

  const handleTimezoneChange = async (tz: string | null) => {
    const prevTz = activeTz;
    setActiveTz(tz);
    try {
      const entriesParams: any = {
        page: {size: 2, index: 0},
        sortBy: 'updatedAt',
        sort: 'DESC',
        hiveId: {},
      };

      await updateUserTz({timezone: tz});
      await Promise.all([
        currentApiary && getEventsFromServer({apiaryId: currentApiary.id}),
        currentApiary && getDiaryEntriesTyped({...entriesParams, apiaryId: currentApiary.id}),
        currentApiary && getAudiosFromServer(currentApiary.id),
        user && getNotificationsFromServer({userId: user.id, status: 'NEW'}),
        getJournalEntries(),
        getCurrentHiveInfo(),
        setUserNowDate(getNowForUserTz()),
      ]);
    } catch {
      toast.error('При смене часового пояса произошла ошибка');
      setActiveTz(prevTz);
    }
  };

  return {
    handleTimezoneChange,
    activeTz,
    timezones,
  };
};
